import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
    selector: '[appPreventCopy]',
    standalone: false
})
export class PreventCopyDirective {
  @HostBinding('style.user-select') userSelect = 'none';
  @HostBinding('style.webkit-user-select') webkitUserSelect = 'none';

  @HostListener('copy', ['$event'])
  @HostListener('cut', ['$event'])
  @HostListener('contextmenu', ['$event'])
  @HostListener('selectstart', ['$event'])
  @HostListener('dragstart', ['$event'])
  blockClipboardEvents(event: Event): void {
    if (this.isEditableTarget(event.target)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('keydown', ['$event'])
  blockCopyShortcuts(event: KeyboardEvent): void {
    if (this.isEditableTarget(event.target)) {
      return;
    }

    const isCopyShortcut = (event.ctrlKey || event.metaKey) && ['c', 'x', 'a'].includes(event.key.toLowerCase());
    if (!isCopyShortcut) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
  }

  private isEditableTarget(target: EventTarget | null): boolean {
    if (!(target instanceof HTMLElement)) {
      return false;
    }

    return !!target.closest('input, textarea, [contenteditable="true"]');
  }
}
